/**
 * Chart Theme Configuration
 * Monumenta brand colors and responsive breakpoints for data visualizations
 */

export const chartTheme = {
  colors: {
    // Brand
    primary: '#D2FA52',        // Lime green accent
    background: '#232429',     // Dark background
    backgroundLight: '#2A2D34', // Elevated background

    // Semantic
    positive: '#10B981',       // Green (good variance)
    negative: '#EF4444',       // Red (bad variance)
    warning: '#F59E0B',        // Yellow (caution)
    neutral: '#9CA3AF',        // Gray (target/baseline)

    // Text
    textPrimary: '#FFFFFF',
    textSecondary: '#9CA3AF',

    // Variance scale (for heatmap)
    varianceScale: [
      '#DC2626',  // -50%+ (deep red)
      '#EF4444',  // -25% to -50% (red)
      '#F87171',  // -10% to -25% (light red)
      '#FBBF24',  // -10% to +10% (yellow)
      '#4ADE80',  // +10% to +25% (light green)
      '#10B981',  // +25% to +50% (green)
      '#059669'   // +50%+ (deep green)
    ]
  },

  fonts: {
    primary: 'Helvetica Now Display, sans-serif',
    mono: 'SF Mono, Monaco, Consolas, monospace'
  },

  spacing: {
    chartPadding: 16,
    legendGap: 12,
    tooltipPadding: 8
  },

  responsive: {
    mobile: { width: 320, height: 200, fontSize: 10 },
    tablet: { width: 500, height: 300, fontSize: 12 },
    desktop: { width: 700, height: 400, fontSize: 14 }
  }
}

export type ChartSize = 'sm' | 'md' | 'lg'

export const sizeMap: Record<ChartSize, number> = {
  sm: 120,
  md: 180,
  lg: 240
}
